export default __webpack_public_path__ + "static/media/Leggings of the Huntmaster.aba2f1d3.jpg";